import { render, staticRenderFns } from "./UserModify.vue?vue&type=template&id=623be72c&scoped=true&"
import script from "./UserModify.vue?vue&type=script&lang=js&"
export * from "./UserModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623be72c",
  null
  
)

export default component.exports